import { Link } from "react-router-dom";
import { useTokenStore } from "../../store/TokenStore";
import styled from "styled-components";

export const Navigation = () => {
	const token = useTokenStore((state) => state.token);
	const TokenReset = useTokenStore((state) => state.TokenReset);

	return (
		<StyledComponent>
			{!token ? (
				<></>
			) : (
				<>
					<Link to="/">
						<div>Главная</div>
					</Link>
					<Link to="/staking">
						<div>Стэйкинг</div>
					</Link>
					<Link to="/transfer">
						<div>Переводы</div>
					</Link>
					<Link to="/logs">
						<div>Логи</div>
					</Link>
					<Link to="/sync">
						<div>Синхронизация</div>
					</Link>
					<Link to="/">
						<div onClick={() => TokenReset()}>Выход</div>
					</Link>
				</>
			)}
		</StyledComponent>
	);
};

const StyledComponent = styled.nav`
	display: flex;
	flex-direction: column;
	gap: 1px;

	& > a > div {
		padding: 1rem;
		background-color: rgba(0, 0, 0, 0.3);
		font-size: 1.2rem;

		&:hover {
			background-color: rgba(0, 0, 0, 0.4);
		}
	}
`;
